import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../../../useApiMutation';

const useSetMarketplaceHostProfile = () => {
  const queryClient = useQueryClient();
  const mutation = useApiMutation({
    getRequestUrl: ({ showId, profileId }) =>
      `/shows/${showId}/marketplace/profiles/hosts/${profileId}`,
    method: 'PATCH',
    onSuccess: (data) => {
      queryClient.invalidateQueries(keys.hostProfiles({ showId: data.showId }));
      queryClient.invalidateQueries(
        keys.hostProfile({ showId: data.showId, profileId: data._id.toString() })
      );
    },
  });

  return {
    setHostProfile: mutation.mutate,
    setHostProfileAsync: mutation.mutateAsync,
    isSetHostProfileLoading: mutation.isLoading,
    isSetHostProfileError: mutation.isError,
    isSetHostProfileSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useSetMarketplaceHostProfile;
